/** 通用 */
export default {
    add: "add", // 新增
    operate: "ดำเนินการ", // 操作
    update: "อัปเดต", // 修改
    delete: "ลบ", // 删除
    search: "ค้นหา", // 搜索
    refresh: "รีเฟรช", // 重置 刷新
    export: "ส่งออก", // 导出
    systemStatus: "สถานะระบบ", // 系统状态
    systemStatusPlaceholder: "สถานะระบบ", // 请选择系统状态
    remark: "หมายเหตุ", // 备注
    numericalOrder: "หมายเลขซีเรียล", // 序号
    welcome: "ยินดีต้อนรับ", // 欢迎您
    goBack: "กลับ", // 返回
}
